import { Reveal, SectionLabel } from "@/components/Reveal";

export default function WhyGlutathione() {
  return (
    <section
      id="glutathione"
      data-testid="glutathione-section"
      className="relative z-10 bg-surface border-y border-champagne py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="max-w-3xl">
          <SectionLabel index="02">Why Glutathione Matters</SectionLabel>
        </div>

        <Reveal>
          <blockquote className="font-serif font-light tracking-tight leading-[1.08] text-3xl md:text-5xl lg:text-[3.4rem] text-[color:var(--relumia-ink)] max-w-5xl">
            “Glutathione is the body’s{" "}
            <span className="italic text-gold">master antioxidant</span> — the
            single molecule that defends every cell, and quietly decides how your
            skin ages and glows.”
          </blockquote>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-10">
          {[
            [
              "Defends every cell",
              "It neutralises free radicals from UV, pollution and stress — the invisible drivers of dullness, dark spots and premature ageing.",
            ],
            [
              "Regulates pigment",
              "By inhibiting tyrosinase, glutathione shifts melanin toward lighter tones, fading pigmentation and revealing an even, luminous complexion.",
            ],
            [
              "Declines with age",
              "Natural glutathione levels fall from your mid-twenties. Supplementation restores what time and environment take away.",
            ],
          ].map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.12}>
              <div className="border-t border-[color:var(--relumia-ink)]/15 pt-6">
                <div className="font-serif text-2xl text-[color:var(--relumia-ink)] mb-3">
                  {t}
                </div>
                <p className="text-[14.5px] leading-relaxed text-[color:var(--relumia-muted)]">
                  {d}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
